export enum Roles {
  /** Globalny Admin - dla właściciela systemu */
  Admin = 'admin',
  /** Audytor - użytkownik mogący przeprawodzić audyty */
  Auditor = 'editor',
  /** Audytor Weryfikator - użytkownik mogący przeprowadzić audyt oraz dokonać oceny ryzka */
  AuditorVerifier = 'editor-verifier',
  /** Pełnomocnik - użytkownik mający najwyższe uprawnienia w firmie */
  Agent = 'agent',
  /** Weryfikator - użytkownik mogący dokonać oceny ryzka */
  Verifier = 'verifier',
}

export enum RolesIds {
  Admin = 1,
  Auditor = 2,
  Agent = 3,
  AuditorVerifier = 4,
  Verifier = 5,
}

export enum RolesNames {
  Admin = 'Administrator',
  Auditor = 'Auditor',
  AuditorVerifier = 'Auditor Weryfikator',
  Agent = 'Pełnomocnik',
  Verifier = 'Weryfikator',
}
